import React from 'react';
import { observer } from 'mobx-react';

import { Button } from '@smartplatform/ui';
import Tree from './Tree';
import SimpleList from './SimpleList';

import store from '../../store';

@observer
export default class List extends React.Component {
	
	constructor(props) {
		super(props);
		this.isAdmin = store.model.roles ? store.model.roles.findIndex(role => role.name === 'admin') !== -1 : false;
	}

	create = () => this.props.history.push('/admin/static/create');
	
	toggle = e => {
		store.local.expandPages = !store.local.expandPages;
		store.local.save();
		console.log('toggle', store.local.expandPages);
	};
	
	render() {
		console.log('store.local.expandPages', store.local.expandPages);
		return <>
			<p>Статичные страницы</p>
			{this.isAdmin && <p>
				<Button className="btn-primary" onClick={this.create}>Создать</Button>
				{' '}
				<input type="checkbox" checked={store.local.expandPages} onChange={this.toggle} /> Раскрыть все
			</p>}
			{this.isAdmin ? <Tree /> : <SimpleList />}
		</>;
	}
	
}
